// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a9c7b301","455":"e6c48906"}[chunkId] + ".chunk.js";
};